import React, { useEffect, useState } from "react"
import { useSiteContext } from "../hooks/use-site-context"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"
import { FaHeart } from "react-icons/fa"
import { MdPlayArrow, MdPause, MdVolumeOff, MdVolumeUp } from "react-icons/md"
import { v4 as uuidv4 } from "uuid"

const EnterLastAndEmail = () => {
  const {
    firstName,
    selectedSign,
    setLastName,
    setEmailAddress,
    mainAudio,
    setCurrentAudioStage,
    setCurrentStep,
    setAudioEnded,
    progressBarPercent,
    setProgressBarPercent,
    buttonClickAudio,
    userCountry,
    userCity,
    userRegion,
  } = useSiteContext()

  const [lName, setLName] = useState("")
  const [email, setEmail] = useState("")
  const [isFormNameError, setIsFormNameError] = useState(false)
  const [isFormEmailError, setIsFormEmailError] = useState(false)
  const [disappearing, setDisappearing] = useState(false)

  const isBrowser = typeof window !== "undefined"

  const getSHA256Hash = async input => {
    const textAsBuffer = new TextEncoder().encode(input)
    const hashBuffer = await window.crypto.subtle.digest(
      "SHA-256",
      textAsBuffer
    )
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    return hashArray.map(item => item.toString(16).padStart(2, "0")).join("")
  }

  async function conversionsAPI(eventID, eventType) {
    const cookies = document.cookie.split(";")
    let fbp = "none"
    let fbc = "none"

    cookies.map(cookie => {
      if (cookie.includes("_fbp=")) {
        fbp = cookie.slice(cookie.indexOf("_fbp=") + 5)
        console.log(fbp)
      }
    })
    cookies.map(cookie => {
      if (cookie.includes("_fbc=")) {
        fbc = cookie.slice(cookie.indexOf("_fbc=") + 5)
        console.log(fbc)
      }
    })

    if (fbc === "none" && window.location.search.includes("fbclid=")) {
      const params = new URL(document.location).searchParams
      fbc = "fb.1." + new Date() + "." + params.get("fbclid")
    }
    try {
      console.log("Email:", email.trim().toLowerCase())
      console.log("Fname:", firstName.toLowerCase())
      const hashedEmail = await getSHA256Hash(email.trim().toLowerCase())
      const hashedFirstName = await getSHA256Hash(firstName.toLowerCase())
      const res = await fetch("/.netlify/functions/conversions-api", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          eventType: eventType,
          email: hashedEmail,
          firstName: hashedFirstName,
          fbp,
          fbc,
          sessionID: eventID,
        }),
      })
      const result = await res.json()
      console.log("Return from netlify functions conversionsAPI =", result)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }

  function xorEncrypt(str, key) {
    return str
      .split("")
      .map((char, i) =>
        String.fromCharCode(char.charCodeAt(0) ^ key.charCodeAt(i % key.length))
      )
      .join("")
  }

  function base64UrlEncode(str) {
    const base64 = btoa(str) // Browser-safe Base64
    return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")
  }

  function generateSlug({ v1, v2, v3 }, key) {
    const payloadStr = `${v1}|${v2}|${v3}`
    const encrypted = xorEncrypt(payloadStr, key)
    return base64UrlEncode(encrypted)
  }

  async function addAbandonedCart() {
    let eventID = uuidv4()
    console.log(eventID)
    if (isBrowser && window.fbq)
      window.fbq("track", "Lead", {}, { eventID: eventID })

    const capi = await conversionsAPI(eventID, "Lead")

    let temp1 = ""
    let temp2 = ""

    temp1 = escape(firstName)
    for (let i = 0; i < temp1.length; i++) {
      temp2 += temp1.charCodeAt(i) - 23
    }

    let temp3 = ""
    let temp4 = ""

    temp3 = escape(email.trim().toLowerCase())
    for (let i = 0; i < temp3.length; i++) {
      temp4 += temp3.charCodeAt(i) - 23
    }

    let temp5 = ""
    let temp6 = ""

    temp5 = escape(selectedSign)
    for (let i = 0; i < temp5.length; i++) {
      temp6 += temp5.charCodeAt(i) - 23
    }

    let temp7 = ""
    let temp8 = ""

    temp7 = escape(
      lName.trim().charAt(0).toUpperCase() + lName.trim().slice(1).toLowerCase()
    )
    for (let i = 0; i < temp7.length; i++) {
      temp8 += temp7.charCodeAt(i) - 23
    }

    const fields = {
      email: email,
      firstname: firstName,
      lastname:
        lName.trim().charAt(0).toUpperCase() +
        lName.trim().slice(1).toLowerCase(),
      star_sign: selectedSign,
      guid: uuidv4().replace(/-/g, ""),
      recovery_url: `https://www.thetruthinyourstars.com/wb/${generateSlug(
        {
          v1: email,
          v2: 0,
          v3: 0,
        },
        "truthstars"
      )}`,
      recovery_discount_url: `https://www.thetruthinyourstars.com/wb/${generateSlug(
        {
          v1: email,
          v2: 1,
          v3: 0,
        },
        "truthstars"
      )}`,
      recovery_lucky_wheel_url: `https://www.thetruthinyourstars.com/lw/${generateSlug(
        {
          v1: email,
          v2: 0,
          v3: 0,
        },
        "truthstars"
      )}`,
      source_url: window.location.href,
      user_agent: navigator.userAgent,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      browser_language: navigator.language,
      // recovery_url: `https://truthstars.pay.clickbank.net/?cbitems=9&cbfid=58060&template=orderforml&exitoffer=exit2&email=${email
      //   .trim()
      //   .toLowerCase()}&sign=${selectedSign}&fname=${temp2}&lname=${temp8}`,
      // recovery_discount_url: `https://truthstars.pay.clickbank.net/?cbitems=10&cbfid=58060&template=orderforml&exitoffer=exit2&email=${email
      //   .trim()
      //   .toLowerCase()}&sign=${selectedSign}&fname=${temp2}&lname=${temp8}`,
    }

    if (localStorage.getItem("astroveo_ClickID")) {
      fields.astroveo_click_id = localStorage.getItem("astroveo_ClickID")
    }

    let ipAddress = null

    try {
      let res = await fetch("https://api.ipify.org")
      ipAddress = await res.text()
    } catch (error) {
      console.log(error)
    }

    if (ipAddress) {
      fields.ip_address = ipAddress
    }

    if (userCountry) {
      fields.country = userCountry
      fields.city = userCity
      fields.region = userRegion
    }

    console.log("Abandoned cart info: ", fields)

    const groups = ["122586811857896477"]

    const response = await fetch("/.netlify/functions/mautic", {
      method: "POST",
      body: JSON.stringify({ fields }),
    })
    const res = await response.json()

    // Fire MGID lead conversion, if applicable
    let mgidID = localStorage.getItem("mgidClickID")
    if (mgidID) {
      const postbackURL = `https://a.mgid.com/postback/896282?c=${mgidID}&e=lead&r=0`

      try {
        const mgidResponse = await fetch(postbackURL)
        if (mgidResponse.ok) {
          const mgidData = await mgidResponse.text()
          console.log("mgidAds postback sent successfully:", mgidData)
        } else {
          console.error("Error with mgidAds postback:", mgidResponse.status)
        }
      } catch (error) {
        console.error(
          "Fetch error (mgidAds conversion postback fetch):",
          error.message
        )
      }
    }
  }

  const handleClick = () => {
    let hasError = false

    if (lName.trim() === "") {
      hasError = true
      setIsFormNameError(true)
      // setTimeout(() => setIsFormNameError(false), 700)
    } else {
      setIsFormNameError(false)
    }

    if (
      email.trim() === "" ||
      !email.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi)
    ) {
      hasError = true
      setIsFormEmailError(true)
      // setTimeout(() => setIsFormEmailError(false), 700)
    } else {
      setIsFormEmailError(false)
    }

    if (hasError) {
      const isFirefox = navigator.userAgent.toLowerCase().includes("firefox")

      if (isFirefox) {
        // Custom smooth scroll for Firefox
        const smoothScrollToTop = () => {
          let currentScroll = window.scrollY
          if (currentScroll > 0) {
            window.scrollTo(0, currentScroll - currentScroll / 8) // Adjust easing factor if needed
            requestAnimationFrame(smoothScrollToTop)
          }
        }
        requestAnimationFrame(smoothScrollToTop)
      } else {
        // Native smooth scroll for Chrome, Safari, and others
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        })
      }
      return
    }

    buttonClickAudio.play()

    setLastName(
      lName.trim().charAt(0).toUpperCase() + lName.trim().slice(1).toLowerCase()
    )
    setEmailAddress(email.trim().toLowerCase())
    setDisappearing(true)
    setTimeout(() => {
      setCurrentAudioStage("wonderful")
      mainAudio.src = `/audio/wonderful.mp3`
      mainAudio.play()
      setAudioEnded(false)
      setCurrentStep(8)
    }, 700)
    let currentTick = 0
    const intervalID = setInterval(() => {
      currentTick++
      if (currentTick >= 3870 || progressBarPercent > 99) {
        setProgressBarPercent(100)
        clearInterval(intervalID)
      } else {
        setProgressBarPercent(progressBarPercent =>
          progressBarPercent > 99.9
            ? 100
            : progressBarPercent + 33.333333 / 3870
        )
      }
    }, 100)

    addAbandonedCart()
  }

  // useEffect(() => {
  //   document.body.style.overflow = "auto"
  // }, [])

  return (
    <>
      <div
        className={`text-center fade-in ${
          disappearing ? "disappear transition duration-1000" : ""
        }`}
      >
        <h1 className="text-2xl font-bold text-white md:text-4xl">
          Next Step: Your Future, {firstName}...
        </h1>
        <p className="mt-6 text-lg font-semibold sm:mt-12 text-brand-gold">
          Enter your last name:
        </p>
        <input
          value={lName}
          className={`${
            isFormNameError ? "ring-0 focus:ring-2" : "ring-0 focus:ring-2"
          } w-full max-w-xs p-2 mt-2 transition ring-brand-pink duration-150 ease-in-out rounded-sm outline-none md:max-w-sm focus:outline-none`}
          placeholder="Your last name"
          type="text"
          onChange={e => {
            setLName(e.target.value)
          }}
          onKeyDown={e => {
            if (e.key === "Enter" && !disappearing) handleClick()
          }}
        />
        {isFormNameError && (
          <p className="max-w-xs mx-auto text-white bg-red-700 bg-opacity-60 md:max-w-sm">
            ☝ Please enter your last name.
          </p>
        )}
        <p className="mt-2 text-lg font-semibold text-brand-gold">
          Enter your best email address:
        </p>
        <input
          value={email}
          className={`${
            isFormEmailError ? "ring-0 focus:ring-2" : "ring-0 focus:ring-2"
          } w-full max-w-xs p-2 mt-2 transition ring-brand-pink duration-150 ease-in-out rounded-sm outline-none md:max-w-sm focus:outline-none`}
          placeholder="Your best email address"
          type="email"
          onChange={e => {
            setEmail(e.target.value)
          }}
          onKeyDown={e => {
            if (e.key === "Enter" && !disappearing) handleClick()
          }}
        />
        {isFormEmailError && (
          <p className="max-w-xs mx-auto text-white bg-red-700 bg-opacity-60 md:max-w-sm">
            ☝ Please enter a valid email address.
          </p>
        )}
        <p className="max-w-xs mx-auto mt-4 mb-4 text-white bg-black bg-opacity-50 md:max-w-sm">
          🔒 I value your trust. Your information is secure and confidential.
        </p>
        {/* <br /> */}
        <div className="relative">
          <button
            onClick={() => handleClick()}
            disabled={disappearing}
            type="button"
            style={{
              backgroundColor: "rgb(168, 24, 129)",
              boxShadow: "0 0 1px 3px rgba(180, 23, 120, 0.45)",
            }}
            className="w-full max-w-xs py-2 mt-0 font-bold text-white rounded-sm continue-pulse md:max-w-sm"
          >
            Continue
          </button>
          <div className="absolute pointer-events-none right-12 sm:right-24 top-4">
            <StaticImage
              quality={95}
              loading={"eager"}
              src="../images/finger3.png"
              placeholder="blurred"
              alt={"Finger"}
              className={"w-10 h-10 sm:w-12 sm:h-12 finger-motion"}
            />
          </div>
        </div>
        <div className="flex w-full max-w-xs px-3 py-6 mx-auto mt-6 bg-black bg-opacity-50 md:px-4 md:max-w-sm">
          <div className="flex justify-center w-1/3">
            <StaticImage
              quality={95}
              loading={"eager"}
              src="../images/phillip.jpg"
              placeholder="blurred"
              alt={"Phillip"}
              className={``}
            />
          </div>
          <div className="w-2/3 pl-2">
            <p className="text-xs italic text-gray-100 md:text-sm">
              I always <span className="font-bold">used to feel</span> like I
              was <span className="font-bold">cursed.</span> I had bad luck in
              love, bad luck in money, and was spiritually unfulfilled. Then{" "}
              <span className="font-bold">James</span> came along, and{" "}
              <span className="font-bold">changed my life.</span> Thank you,
              James!
              <br />
              <span className="font-bold">- Phillip K. (Denver, Colorado)</span>
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default EnterLastAndEmail
